module.exports = __webpack_public_path__ + "img/wrapbg4.41621aeb.png";